export const learnMoreLink =
    'https://support.approvalmax.com/portal/en/kb/articles/how-to-set-up-approvalmax-capture-via-email';
